(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gfx-layer"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    if (window.__bbGfx) {
      window.__bbGfx.scan();
      return;
    }

    var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobileMq = window.matchMedia('(max-width: 749px)');
    var coarseMq = window.matchMedia('(hover: none), (pointer: coarse)');
    var registry = new WeakMap();

    function clamp(v, a, b) {
      return Math.min(b, Math.max(a, v));
    }

    function rnd(a, b) {
      return a + Math.random() * (b - a);
    }

    function parseColor(hex) {
      var m = /^#?([0-9a-f]{3}|[0-9a-f]{6})/i.exec(hex || '');
      if (!m) return [255, 241, 214];
      var h = m[1];
      if (h.length === 3) h = h.replace(/./g, '$&$&');
      return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
    }

    /* ---------------------------------------------------------------
       Particles: dust, snow, embers, steam
    --------------------------------------------------------------- */
    function Particles(canvas, type, density, color) {
      var ctx = canvas.getContext('2d');
      var c = parseColor(color).join(',');
      var sprite = document.createElement('canvas');
      sprite.width = sprite.height = 64;
      var sctx = sprite.getContext('2d');
      var g = sctx.createRadialGradient(32, 32, 0, 32, 32, 32);
      g.addColorStop(0, 'rgba(' + c + ',1)');
      g.addColorStop(0.35, 'rgba(' + c + ',0.5)');
      g.addColorStop(1, 'rgba(' + c + ',0)');
      sctx.fillStyle = g;
      sctx.fillRect(0, 0, 64, 64);

      var list = [];
      var w = 0;
      var h = 0;
      var ptr = { x: -9999, y: -9999 };

      function make(initial) {
        var p = { x: rnd(0, w), y: 0, bvx: 0, bvy: 0, vx: 0, vy: 0, s: 0, a: 0, life: 0, max: 10, ph: rnd(0, 6.28), sw: 5 };
        if (type === 'embers') {
          p.y = initial ? rnd(0, h) : h + 10;
          p.s = rnd(3, 8);
          p.a = rnd(0.55, 1);
          p.bvy = rnd(-90, -35);
          p.bvx = rnd(-10, 10);
          p.sw = rnd(8, 24);
          p.max = (h / -p.bvy) * rnd(0.7, 1.1);
        } else if (type === 'snow') {
          p.y = initial ? rnd(0, h) : -10;
          p.s = rnd(2.5, 6);
          p.a = rnd(0.5, 0.95);
          p.bvy = rnd(25, 70);
          p.bvx = rnd(-8, 8);
          p.sw = rnd(8, 22);
          p.max = (h / p.bvy) * 1.1;
        } else if (type === 'steam') {
          p.x = rnd(w * 0.1, w * 0.9);
          p.y = initial ? rnd(h * 0.3, h) : h + 40;
          p.s = rnd(60, 130);
          p.a = rnd(0.05, 0.11);
          p.bvy = rnd(-26, -12);
          p.bvx = rnd(-4, 4);
          p.sw = rnd(14, 36);
          p.max = rnd(7, 13);
        } else {
          p.y = rnd(0, h);
          p.s = rnd(4, 11);
          p.a = rnd(0.25, 0.8);
          p.bvy = rnd(-10, -2);
          p.bvx = rnd(-6, 6);
          p.sw = rnd(2, 8);
          p.max = rnd(8, 20);
        }
        p.vx = p.bvx;
        p.vy = p.bvy;
        if (initial) p.life = rnd(0, p.max * 0.8);
        return p;
      }

      function resize() {
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        w = canvas.clientWidth;
        h = canvas.clientHeight;
        if (!w || !h) return;
        canvas.width = Math.round(w * dpr);
        canvas.height = Math.round(h * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var per = type === 'steam' ? 90000 : type === 'snow' ? 6000 : 7000;
        var cap = type === 'steam' ? 14 : 260;
        var n = Math.min(cap, Math.max(type === 'steam' ? 3 : 8, Math.round((density / 100) * (w * h) / per)));
        while (list.length < n) list.push(make(true));
        list.length = n;
      }

      function step(dt) {
        if (!w || !h) return;
        ctx.clearRect(0, 0, w, h);
        ctx.globalCompositeOperation = type === 'steam' || type === 'snow' ? 'source-over' : 'lighter';
        for (var i = 0; i < list.length; i++) {
          var p = list[i];
          p.life += dt;
          if (p.life >= p.max) {
            p = list[i] = make(false);
          }
          var sway = Math.sin(p.life * 0.9 + p.ph) * p.sw;
          p.x += (p.vx + sway) * dt;
          p.y += p.vy * dt;

          if (type !== 'steam') {
            var dx = p.x - ptr.x;
            var dy = p.y - ptr.y;
            var d2 = dx * dx + dy * dy;
            if (d2 < 12100 && d2 > 1) {
              var d = Math.sqrt(d2);
              var f = (1 - d / 110) * 220 * dt;
              p.vx += (dx / d) * f;
              p.vy += (dy / d) * f;
            }
          }
          var relax = Math.min(1, dt * 1.5);
          p.vx += (p.bvx - p.vx) * relax;
          p.vy += (p.bvy - p.vy) * relax;

          if (p.x < -p.s * 2) p.x = w + p.s;
          if (p.x > w + p.s * 2) p.x = -p.s;
          if (type === 'dust') {
            if (p.y < -p.s) p.y = h + p.s;
            if (p.y > h + p.s) p.y = -p.s;
          }

          var fade = clamp(Math.min(p.life, p.max - p.life) / (p.max * 0.25), 0, 1);
          var alpha = p.a * fade;
          if (type === 'dust') alpha *= 0.65 + 0.35 * Math.sin(p.life * 2 + p.ph);
          var size = p.s * (type === 'steam' ? 1 + (p.life / p.max) * 0.8 : 1);
          ctx.globalAlpha = clamp(alpha, 0, 1);
          ctx.drawImage(sprite, p.x - size, p.y - size, size * 2, size * 2);
        }
        ctx.globalAlpha = 1;
      }

      return {
        resize: resize,
        step: step,
        pointer: function (x, y) {
          ptr.x = x;
          ptr.y = y;
        },
        clear: function () {
          if (w && h) ctx.clearRect(0, 0, w, h);
        }
      };
    }

    /* ---------------------------------------------------------------
       Group blocks: move the layer into the group's media wrapper so it
       sits exactly where the theme's own background image lives (full
       block, padding included). Media blocks: the layer is already in the
       right place (directly inside .media-block), so nothing moves.
    --------------------------------------------------------------- */
    function findHost(layer) {
      var parent = layer.parentElement;
      if (parent && parent.classList.contains('group-block-content')) {
        var block = parent.closest('.group-block');
        if (block) {
          var kids = block.children;
          for (var i = 0; i < kids.length; i++) {
            if (kids[i].classList.contains('group-block__media-wrapper')) {
              kids[i].appendChild(layer);
              break;
            }
          }
        }
      }
      return layer.parentElement;
    }

    /* ---------------------------------------------------------------
       Effect controller for one layer
    --------------------------------------------------------------- */
    function Fx(layer) {
      var host = findHost(layer);
      // Group: the wrapper sits behind the content, so listen on the whole block.
      var block = host.classList.contains('group-block__media-wrapper')
        ? (host.closest('.group-block') || host)
        : host;
      var media = layer.querySelector('.gfx-media');
      var canvas = layer.querySelector('.gfx-canvas');
      var d = layer.dataset;
      var follow = d.follow ? host.querySelector(d.follow) : null;
      var fro = null;
      var effect = d.effect || 'none';
      var k = (parseFloat(d.intensity) || 50) / 100;
      var bleed = (parseFloat(d.bleed) || 10) / 100;
      var allowMobile = d.mobile !== 'false';
      var particles = canvas && d.particles && d.particles !== 'none'
        ? Particles(canvas, d.particles, parseFloat(d.density) || 40, d.color)
        : null;

      var visible = false;
      var raf = 0;
      var last = 0;
      var dead = false;
      var first = true;
      var ps = 0;
      var mx = 0;
      var my = 0;
      var mxs = 0;
      var mys = 0;
      var lastT = '';
      var lastF = '';
      var radiusCss = null;
      var io = null;
      var ro = null;

      function canRun() {
        return !reduceMq.matches && (allowMobile || !mobileMq.matches);
      }

      function put(tx, ty, sc, rot, rx, ry, blur, hue, sat) {
        var t = 'perspective(1200px) translate3d(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px,0) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) rotate(' + rot.toFixed(2) + 'deg) scale(' + sc.toFixed(4) + ')';
        if (t !== lastT) {
          media.style.transform = t;
          lastT = t;
        }
        var f = blur > 0.05 || Math.abs(hue) > 0.1 || Math.abs(sat - 1) > 0.01
          ? 'blur(' + blur.toFixed(2) + 'px) hue-rotate(' + hue.toFixed(1) + 'deg) saturate(' + sat.toFixed(3) + ')'
          : '';
        if (f !== lastF) {
          media.style.filter = f;
          lastF = f;
        }
      }

      function frame(t) {
        raf = 0;
        if (dead) return;
        if (!layer.isConnected) {
          destroy();
          return;
        }

        var dt = last ? Math.min((t - last) / 1000, 0.05) : 0.016;
        last = t;
        syncFrame();

        var r = layer.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        var raw = clamp(((r.top + r.height / 2) - vh / 2) / ((vh + r.height) / 2), -1, 1);
        if (first) {
          ps = raw;
          first = false;
        }
        ps += (raw - ps) * 0.14;
        mxs += (mx - mxs) * 0.08;
        mys += (my - mys) * 0.08;

        var sy = r.height * bleed * 0.9;
        var sx = r.width * bleed * 0.9;
        var noHover = coarseMq.matches;

        var tx = 0, ty = 0, sc = 1, rot = 0, rx = 0, ry = 0, blur = 0, hue = 0, sat = 1;
        var clip = 0;
        var e;

        switch (effect) {
          case 'parallax':
            ty = -ps * sy;
            break;
          case 'parallax_reverse':
            ty = ps * sy;
            break;
          case 'zoom_in':
            sc = 1 + ((1 - ps) / 2) * k * 0.45;
            break;
          case 'zoom_out':
            sc = 1 + (1 - (1 - ps) / 2) * k * 0.45;
            break;
          case 'drift':
            tx = ps * sx;
            break;
          case 'rotate': {
            var deg = ps * (2 + 8 * k);
            var rad = Math.abs(deg) * Math.PI / 180;
            var ar = Math.max(r.width / r.height, r.height / r.width);
            rot = deg;
            sc = Math.cos(rad) + ar * Math.sin(rad);
            break;
          }
          case 'blur_focus':
            blur = Math.abs(ps) * k * 14;
            ty = -ps * sy * 0.5;
            sc = 1 + Math.abs(ps) * k * 0.05;
            break;
          case 'reveal':
            e = clamp((1 - ps) / 0.9, 0, 1);
            clip = (1 - e) * k * 28;
            sc = 1 + (1 - e) * k * 0.25;
            break;
          case 'hue_shift':
            hue = ps * k * 70;
            sat = 1 + Math.abs(ps) * k * 0.4;
            ty = -ps * sy * 0.5;
            break;
          case 'tilt':
            if (noHover) {
              ty = -ps * sy;
            } else {
              rx = -mys * k * 6;
              ry = mxs * k * 8;
              tx = -mxs * sx * 0.6;
              ty = -mys * sy * 0.6 - ps * sy * 0.3;
              sc = 1 + k * 0.06;
            }
            break;
          case 'spotlight': {
            ty = -ps * sy * 0.4;
            var px = noHover ? 50 : (mxs + 1) * 50;
            var py = noHover ? 50 + ps * -30 : (mys + 1) * 50;
            layer.style.setProperty('--gfx-mx', px.toFixed(1) + '%');
            layer.style.setProperty('--gfx-my', py.toFixed(1) + '%');
            layer.style.setProperty('--gfx-spot-r', Math.round(140 + k * 320) + 'px');
            break;
          }
          default:
            break;
        }

        put(tx, ty, sc, rot, rx, ry, blur, hue, sat);

        if (clip > 0.01 && radiusCss === null) {
          radiusCss = window.getComputedStyle(layer).borderTopLeftRadius || '0px';
        }
        var cp = clip > 0.01
          ? 'inset(' + clip.toFixed(2) + '% ' + (clip * 0.6).toFixed(2) + '% round ' + radiusCss + ')'
          : '';
        if (layer.style.clipPath !== cp) layer.style.clipPath = cp;

        if (particles) particles.step(dt);

        if (visible) raf = requestAnimationFrame(frame);
      }

      function start() {
        if (!raf && visible && !dead && canRun()) {
          last = 0;
          raf = requestAnimationFrame(frame);
        }
      }

      function stop() {
        if (raf) {
          cancelAnimationFrame(raf);
          raf = 0;
        }
      }

      function reset() {
        lastT = '';
        lastF = '';
        media.style.transform = '';
        media.style.filter = '';
        layer.style.clipPath = '';
        if (particles) particles.clear();
      }

      // Image block: keep the layer exactly over the theme's <img>
      function syncFrame() {
        if (!follow) return;
        var w = follow.offsetWidth;
        var h = follow.offsetHeight;
        if (w > 0 && h > 0) {
          var st = layer.style;
          var l = follow.offsetLeft + 'px';
          var t = follow.offsetTop + 'px';
          var ws = w + 'px';
          var hs = h + 'px';
          if (st.left !== l) st.left = l;
          if (st.top !== t) st.top = t;
          if (st.width !== ws) st.width = ws;
          if (st.height !== hs) st.height = hs;
          layer.classList.add('gfx-layer--ready');
        } else {
          layer.classList.remove('gfx-layer--ready');
        }
      }

      function evaluate() {
        radiusCss = null;
        syncFrame();
        if (canRun()) {
          start();
        } else {
          stop();
          reset();
        }
      }

      function onMove(ev) {
        if (ev.pointerType === 'touch') return;
        var r = layer.getBoundingClientRect();
        mx = clamp(((ev.clientX - r.left) / r.width) * 2 - 1, -1, 1);
        my = clamp(((ev.clientY - r.top) / r.height) * 2 - 1, -1, 1);
        if (particles) particles.pointer(ev.clientX - r.left, ev.clientY - r.top);
      }

      function onLeave() {
        mx = 0;
        my = 0;
        if (particles) particles.pointer(-9999, -9999);
      }

      function destroy() {
        if (dead) return;
        dead = true;
        stop();
        if (io) io.disconnect();
        if (ro) ro.disconnect();
        if (fro) fro.disconnect();
        if (follow) follow.removeEventListener('load', syncFrame);
        window.removeEventListener('resize', evaluate);
        block.removeEventListener('pointermove', onMove);
        block.removeEventListener('pointerleave', onLeave);
        registry.delete(layer);
      }

      block.addEventListener('pointermove', onMove, { passive: true });
      block.addEventListener('pointerleave', onLeave, { passive: true });
      window.addEventListener('resize', evaluate, { passive: true });

      if (follow) {
        syncFrame();
        follow.addEventListener('load', syncFrame);
        if ('ResizeObserver' in window) {
          fro = new ResizeObserver(syncFrame);
          fro.observe(follow);
          fro.observe(host);
        }
      }

      if (particles && 'ResizeObserver' in window) {
        ro = new ResizeObserver(function () {
          particles.resize();
        });
        ro.observe(layer);
      } else if (particles) {
        particles.resize();
      }

      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          if (!layer.isConnected) {
            destroy();
            return;
          }
          visible = entries[entries.length - 1].isIntersecting;
          if (visible) {
            start();
          } else {
            stop();
          }
        }, { rootMargin: '120px 0px' });
        io.observe(layer);
      } else {
        visible = true;
        start();
      }

      return { destroy: destroy };
    }

    function scan() {
      var layers = document.querySelectorAll('.gfx-layer[data-gfx]');
      for (var i = 0; i < layers.length; i++) {
        if (!registry.has(layers[i])) registry.set(layers[i], Fx(layers[i]));
      }
    }

    window.__bbGfx = { scan: scan };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }

    /* Pick up layers added later (theme editor re-renders, section rendering API, etc.) */
    var pending = false;
    new MutationObserver(function (records) {
      if (pending) return;
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('.gfx-layer') || n.querySelector('.gfx-layer'))) {
            pending = true;
            requestAnimationFrame(function () {
              pending = false;
              scan();
            });
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
